import { QuickEditApiKey } from './publicApiKey';
import { QuickEditEntryPoint } from './quickEditEntryPoint';

export { QuickEditApiKey, QuickEditEntryPoint };
